import { useMemo } from 'react'
import useSWR from 'swr'
import { fetchReadinessSignals } from '../services/account-readiness.service'
import { deriveReadiness, IReadiness } from '../utils/readiness'

/** How often to look again while the account is still being set up. */
export const READINESS_POLL_MS = 20000

/**
 * The account's readiness for its first campaign, polled while it is not
 * ready and left alone once it is. `null` until the first answer.
 */
export const useAccountReadiness = (
   orgId: string | null | undefined
): { readiness: IReadiness | null; isLoading: boolean; refresh: () => void } => {
   const { data, isLoading, mutate } = useSWR(
      orgId ? ['account-readiness', orgId] : null,
      () => fetchReadinessSignals(orgId as string),
      {
         refreshInterval: (latest) =>
            latest && deriveReadiness(latest).canBuild ? 0 : READINESS_POLL_MS,
         revalidateOnFocus: true,
         dedupingInterval: 5000,
      }
   )
   const readiness = useMemo(() => (data ? deriveReadiness(data) : null), [data])
   return { readiness, isLoading, refresh: () => void mutate() }
}
